module.exports = __webpack_public_path__ + "frontend/images/miles/sky-f334dfc19d65dd965245c1351d36636f.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/miles/sky.jpg
// module id = 323
// module chunks = 2